import type { OutrightHit } from "@/features/search/components/Results/models/outrightHit";
import { useTitles } from "@/hooks/graphql/useTitles";
import { fromUnixTime } from "date-fns";
import { TitleIcon } from "@/features/shell/components/shared/TitleIcon";
import React from "react";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Row } from "./Row/Row";
import { Highlight } from "./Highlight/Highlight";
import { NextHighlight } from "./Highlight/NextHighlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";

export const OutrightResults = () => {
  const { items, results } = useNormalisedHits<OutrightHit>();
  const titles = useTitles();

  return (
    <ResultsInIndex
      indexName={`Futures`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const urlPrefix =
          item.sportCategory === "conventional" ? "/sports" : "";
        const startTime = item.nextBetStop
          ? fromUnixTime(item.nextBetStop)?.toISOString()
          : undefined;

        const tournamentHighlight = item.normalisedHighlights?.tournament?.[0];
        const eventHighlight = item.normalisedHighlights?.event?.[0];

        return (
          <Row
            key={item.objectID}
            eventId={item.objectID}
            icon={<TitleIcon title={titles[item.sport?.toLowerCase()]} />}
            subTitle={
              <Highlight
                text={item.tournament}
                matchedWords={tournamentHighlight?.matchedWords || []}
                html={tournamentHighlight?.value || ""}
              />
            }
            title={
              <Highlight
                text={item.event}
                matchedWords={eventHighlight?.matchedWords || []}
                html={eventHighlight?.value || ""}
              />
            }
            to={`${urlPrefix}/betting/${item.type}/${item.objectID}`}
            startTime={startTime}
            highlight={
              <NextHighlight
                highlights={item.normalisedHighlights}
                ignore={["tournament.0", "event.0"]}
              />
            }
          />
        );
      })}
    </ResultsInIndex>
  );
};
